import React, { memo } from 'react';
import { Typography, Box } from '@mui/material';
import { MySidebar } from '../../libs/theme';
import OrderStatusIcon from './OrderStatusIcon';
import { ArrowRight } from "../../assets/images/icons";
import { getText, trimString } from '../../libs/utils';
import { styled } from '@mui/material/styles';

const ChangedSidebar = styled(MySidebar)(({ theme }) => ({
  marginLeft: '40px',
  maxWidth: '337px',
  [theme.breakpoints.only("md")]: {
    maxWidth: '347px',
  },
  [theme.breakpoints.down("md")]: {
    borderLeft: 0,
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
    padding: "25px 0 0",
    margin: "30px 0 0",
    maxWidth: "100% !important",
  },
}))

const OrderSteps = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.only('sm')]: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    " > div": {
      "&::after": {
        content: '" "',
        width: '13px',
        height: '10px',
        background: 'url(../images/arrow-right.svg) center no-repeat',
        margin: '0 13px'
      },
      "&:last-child::after": {
        display: 'none'
      }
    },
  },
  ".step-item": {
    display: 'flex',
    alignItems: 'center',
    margin: '0 0 11px',
    fontWeight: 500,
    color: theme.palette.primary.grey,
    "&.color-green": {
      color: theme.palette.primary.green
    },
    "&.color-black": {
      color: theme.palette.primary.text
    },
    "&.color-black": {
      color: theme.palette.primary.text
    },
    "&.color-red": {
      color: theme.palette.secondary.main
    },
    "&.color-dark-red": {
      color: theme.palette.primary.darkRed
    },
  }
}))

const MyArrow = styled(Box)(({ theme }) => ({
  width: 50,
  padding: '18px 0 0',
  textAlign: 'center',
  // [theme.breakpoints.only('xs')]: {
  //   textAlign: 'center'
  // }
}))

const Sidebar = ({ id, amount = {}, depositViewType = {}, requisites = {}, fromPaymentSystem = '', toAmount = {}, toPaymentSystem = '', rateValues = {}, ...order }) => {

  let orderStatus = {
    2: getText('orderHeaderState9'),
    3: {
      1: getText('orderSBStage2'),
      2: getText('orderSBStage4'),
    },
    4: getText('orderSBStage5'),
  }

  depositViewType.value === 'BANK' && (orderStatus = { ...orderStatus, 1: getText('orderSBStage0') });
  depositViewType.value === 'CRYPT' && (orderStatus =
  {
    ...orderStatus,
    3: { 1: getText('orderHeaderStateHasTransWait'), 2: getText('orderHeaderStateTransWait'), 3: getText('orderSBStage4') }
  });

  const getStepColor = (step, childStep) => {
    if (order.orderState > step) return 'color-green';
    else if (order.orderState == step) {
      if (step == 1) return 'color-black';
      if (step == 2 && depositViewType.value == 'BANK') return 'color-black';
      else if (step == 3) {
        if (childStep == 1) {
          return (order.paymentStatus.id == 70 || order.paymentStatus.id == 7) ? 'color-red' : 'color-green'
        }
        if (depositViewType.value === 'CRYPT') {
          if (childStep == 2) {
            return order.paymentStatus.id == 71 ? 'color-red' : order.paymentStatus.id == 6 ? 'color-green' : ''
          }
          if (childStep == 3) {
            return order.paymentStatus.id == 6 ? 'color-red' : ''
          }
        } else {
          if (childStep == 2) {
            return order.paymentStatus.id == 6 ? 'color-red' : ''
          }
        }
      }
      else if (step == 4) return 'color-dark-red';
      else return 'color-red';
    }
  }

  const fromWalletString = depositViewType.value != "CHECK" && trimString(requisites.fromNumber) || getText("orderSBUnknow")

  return (
    <ChangedSidebar>
      <Typography variant="4" component="div" sx={{ margin: '0 0 22px' }}>{getText('orPerformNumberHed')} № {id}</Typography>

      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row', md: 'column' }, alignItems: 'start', gap: { xs: '30px', sm: '55px', md: '30px' } }}>
        <Box sx={{ width: { md: '100%', sm: 'auto', xs: '100%' } }}>
          <Typography variant="smallCaption" component="div" sx={{ textTransform: 'uppercase', margin: '0 0 15px' }}>{getText('exchData')}</Typography>
          <Box sx={{ display: 'flex', fontSize: 12 }}>
            <Box sx={{ wordBreak: 'break-word' }}>
              <Box sx={{ fontWeight: 'bold', color: 'primary.greyText' }}>{amount.value + " " + amount.currencyCode}</Box>
              {fromWalletString != " " && <Box sx={{ color: 'primary.grey', whiteSpace: 'nowrap' }}>
                {fromWalletString}
              </Box>}
              <Box sx={{ color: 'primary.grey' }}>{fromPaymentSystem}</Box>
            </Box>
            <MyArrow><ArrowRight /></MyArrow>
            <Box sx={{ wordBreak: 'break-word' }}>
              <Box sx={{ fontWeight: 'bold', color: 'primary.greyText' }}>{toAmount.value + " " + toAmount.currencyCode}</Box>
              <Box sx={{ color: 'primary.grey', whiteSpace: 'nowrap' }}>{trimString(requisites.toNumber)}</Box>
              <Box sx={{ color: 'primary.grey' }}>{toPaymentSystem}</Box>
            </Box>
          </Box>
        </Box>

        <Box>
          <Typography variant="smallCaption" component="div" sx={{ textTransform: 'uppercase', marginBottom: '15px' }}>{getText('accOrderRateData')}</Typography>
          <Box sx={{ fontWeight: 'bold', color: 'primary.greyText', fontSize: 12 }}>
            {rateValues.fromValue} {order.fromCurrency} = {rateValues.toValue} {order.toCurrency}
          </Box>
        </Box>
      </Box>

      <Typography variant="smallCaption" component="div" sx={{ textTransform: 'uppercase', margin: '30px 0 15px' }}>{getText('orderSteps')}</Typography>

      <OrderSteps>
        {Object.keys(orderStatus).map(key => (
          typeof orderStatus[key] === 'string' ? (
            <Box key={key} className={`step-item ${getStepColor(key)}`}>
              <OrderStatusIcon status={key} order={{ depositViewType, ...order }} />
              <Box fontSize={12}>{orderStatus[key]}</Box>
            </Box>
          ) : (
            Object.keys(orderStatus[key]).map((childKey) => (
              <Box key={childKey} className={`step-item ${getStepColor(key, childKey)}`}>
                <OrderStatusIcon status={key} childStatus={childKey} order={{ depositViewType, ...order }} />
                <Box fontSize={12}>{orderStatus[key][childKey]}</Box>
              </Box>
            ))
          )
        ))}
      </OrderSteps>

    </ChangedSidebar>
  )
}

// export default Sidebar
export default memo(Sidebar)